import { ConfigField } from 'types/config';
import * as Yup from 'yup';
import schemas from './schemas';

/**
 * Creates Yup object for given country configuration.
 *
 * createSchema({
 *   company_id: {
 *    visible: true,
 *    rule: 'CZ_COMPANY_ID'
 *    ...
 *   },
 *   ...
 * })
 *
 * @param config See companyStepShape.js for examples
 * @returns Yup.object
 */
const createSchema = <T extends object>(
  config: Record<string, ConfigField | undefined>,
): Yup.ObjectSchema<T> => {
  const fields = Object.entries(config);
  if (!config || !fields || fields?.length === 0) {
    console.error('No config provided to generate schema');
    return Yup.object().shape({}) as Yup.ObjectSchema<T>;
  }
  const schema: Record<string, Yup.Schema> = {};

  fields.forEach(([field, fieldConfig]) => {
    if (fieldConfig && fieldConfig.visible) {
      const { mandatory = false, rule } = fieldConfig;
      if (rule && rule in schemas) {
        schema[field] = schemas[rule](mandatory);
      } else {
        schema[field] = schemas.STRING(mandatory);
        console.warn(`Rule '${rule}' doesn't exist for ${field}`);
      }
    }
  });

  return Yup.object().shape(schema) as Yup.ObjectSchema<T>;
};

export default createSchema;
